export default __webpack_public_path__ + "static/media/9.de190167.jpg";